import React from "react";
import {Button, Timeline} from "antd";
import moment from "moment";
import { Link } from "react-router-dom";
import { formatMoney, formatExchangeRate, displayNumberWithComma } from "utils/utils";
import "./TrackAndTracePanel.scss";
import {downloadOrderReceipt} from "../api/api";

import { FormattedMessage } from "react-intl";
import withUseIntl from "components/withUseIntl";

class TimelineOrderCompleted extends React.Component {
    downloadOrder = () => {
        downloadOrderReceipt('order',this.props.order.id, this.props.order.orderId);
    };
  render() {
    return (
      <Timeline className="track-and-trace-timeline">
        <Timeline.Item dot={<CompletedItemIcon />}>
          <span className="timeline-completed-item"><FormattedMessage id="app.panel.timelineorder.ordersetup"/></span>
          {this.props.order.dateCreated && (
            <div className="timeline-hint-label bp-margin-top-smallest-2">
              <FormattedMessage id="app.panel.timelineorder.completedon"/>{" "}
              {moment(this.props.order.dateCreated).format("MMM DD, YYYY")}
            </div>
          )}
        </Timeline.Item>
        <Timeline.Item dot={<CompletedItemIcon />}>
          <span className="timeline-completed-item">
            <FormattedMessage id="app.panel.timelineorder.waitingpayment"/>
          </span>
          {this.props.order.dateReceived && (
            <div className="timeline-hint-label bp-margin-top-smallest-2">
              <FormattedMessage id="app.panel.timelineorder.completedon"/>{" "}
              {moment(this.props.order.dateReceived).format("MMM DD, YYYY")}
            </div>
          )}
        </Timeline.Item>
        <Timeline.Item dot={<CompletedItemIcon />}>
          <span className="timeline-completed-item">
            <FormattedMessage id="app.panel.timelineorder.payouttobeneficiary"/>
          </span>
          {this.props.order.datePaid && (
            <div className="timeline-hint-label bp-margin-top-smallest-2">
              <FormattedMessage id="app.panel.timelineorder.completedon"/>{" "}
              {moment(this.props.order.datePaid).format("MMM DD, YYYY")}
            </div>
          )}
        </Timeline.Item>
        <Timeline.Item dot={<CompletedItemIcon />}>
          <span className="timeline-completed-item"><FormattedMessage id="app.panel.timelineorder.ordercompleted"/>{' '}<a href="#" onClick={this.downloadOrder}>(<FormattedMessage id="app.panel.timelineorder.receipt"/>)</a></span>
          {this.props.order.dateCompleted && (
            <div className="timeline-hint-label">
              <FormattedMessage id="app.panel.timelineorder.completedon"/>{" "}
              {moment(this.props.order.dateCompleted).format("MMM DD, YYYY")}
            </div>
          )}
        </Timeline.Item>
      </Timeline>
    );
  }
}

function CompletedItemIcon() {
    return <div className="timeline-dot-completed" />;
  }

export default withUseIntl(TimelineOrderCompleted);